import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import Fido from '../utils/Fido';
import LoadingIndicator from "../components/LoadingIndicator";

function ActivityRewrite(props) {
	const [activity, setActivity] = useState();

	let {updateHeader, resetHeader, showSnackbar} = props,
		pathname = props.location.pathname.replace('inbox/rewrite', 'v');

	useEffect(() => {
		updateHeader({
			primary: true, // TODO: unless mobile
			title: "details"
		});

		let fluffy = new Fido();
		(async function loadData() {
			let data = await fluffy.fetch(pathname)
				.catch(error => showSnackbar(error.message));

			if (data) {
				setActivity(data.activity);
			}
		})();

		return () => {
			resetHeader();
			fluffy.dropIt();
		};
	}, [setActivity, pathname, updateHeader, resetHeader, showSnackbar]);

	if(activity) {
		return (
			<Redirect to={{
				pathname: `/inbox/${activity.id}`,
				state: {activity: activity}
			}}/>
		);
	} else {
		return <LoadingIndicator />;
	}
}

ActivityRewrite.propTypes = {
	location: PropTypes.object,
	resetHeader: PropTypes.func,
	updateHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
};

export default ActivityRewrite;
